import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Avatar,
  ListItemAvatar,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';

import { getStyled } from './styles';

import { AuthContext } from '../../context/Auth/AuthContext';

import formatSerializedId from '../../utils/formatSerializedId';
import api from '../../services/api';
import toastError from '../../toasts/toastError';

const ContactListItemCustom = ({ contact, onClick }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleClick = async (selectedContactId) => {
    try {
      const { data: ticket } = await api.post('/tickets-contacts', {
        contactId: selectedContactId,
        whatsappId: user.whatsappId,
        queueId: user.queueId,
        userId: user.id,
      });

      if (ticket !== undefined && ticket.uuid !== undefined) {
        navigate(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      const message =
        err?.response?.data?.error || err?.message || 'Erro desconhecido';

      toastError(
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            paddingRight: '25px',
          }}
        >
          {message}
        </div>,
        {
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
        },
      );
    }
  };

  return (
    <ListItem
      style={classes.contact}
      key={contact.id}
      onClick={() => {
        handleClick(contact.id);
        if (onClick) onClick();
      }}
    >
      <ListItemAvatar style={{ marginLeft: '-8px' }}>
        <Avatar
          sx={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            transform: 'scale(0.75)',
          }}
          src={contact.urlPicture}
          alt='Avatar'
        />
      </ListItemAvatar>
      <ListItemText
        disableTypography
        primary={
          <span style={classes.contactNameWrapper}>
            <Typography
              noWrap
              component='span'
              variant='body2'
              sx={classes.contactNameLabel}
            >
              {contact.name}
            </Typography>
          </span>
        }
        secondary={
          <span style={classes.contactNumberWrapper}>
            <Typography
              noWrap
              component='span'
              variant='body2'
              sx={{ fontSize: '12px' }}
            >
              <span>
                {contact.number
                  ? formatSerializedId(contact.number)
                  : contact.number}
              </span>
            </Typography>
          </span>
        }
      />
    </ListItem>
  );
};

export default ContactListItemCustom;
